// Ограничения эмитента: правила уровня программы, одинаковые для каждой
// выпущенной здесь карты. Они не приходят из конфига и не меняются под
// отдельную карту, поэтому лежат данными рядом с экраном.
//
// Коды MCC вынесены отдельно от подписей намеренно: цифры одинаковы на любом
// языке, а смысл группы несёт переводимый заголовок. Иначе пришлось бы держать
// шестнадцать описаний в четырёх локалях и следить, чтобы они не разъехались.
//
// Показываем это ДО оплаты. Узнать, что карта не берёт нужную категорию, из
// отказа на кассе — худший из возможных способов.

export const BLOCKED_COUNTRIES = ["KP", "IR", "SY"];

export const BLOCKED_MCC_GROUPS = [
  { key: "cash", codes: [4829, 6010, 6011, 6012, 6051, 6211, 6540] },
  { key: "gambling", codes: [7995, 9223] },
  { key: "adult", codes: [5967, 7273, 7297, 7841] },
  { key: "retail", codes: [5921, 5912, 5993] },
];

export const BLOCKED_MCC_TOTAL = BLOCKED_MCC_GROUPS.reduce(
  (sum, group) => sum + group.codes.length,
  0
);
